import React from 'react';
import './SubCategory.css';

const SubCategory = ({ subCategory, activeSubCategories, subCategoriesToggle, activeCategory }) => {
    const { uid } = subCategory;

    const isActive = activeSubCategories.includes(uid);

    return (
        <div
            className={`subCategory`}
            onClick={() => subCategoriesToggle(subCategory.uid)}
            style={
                isActive
                    ? {
                          backgroundColor: activeCategory.color,
                          borderColor: activeCategory.color,
                          color: '#fff',
                      }
                    : {
                          borderColor: activeCategory.color,
                          color: activeCategory.color,
                      }
            }
        >
            {subCategory.label}
        </div>
    );
};

export default SubCategory;
